export default "__VITE_ASSET__B5V$d9MJ__"